import React from 'react';

function MicrophoneOn(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M11.875 2C14.2226 2 16.1345 3.87539 16.245 6.22614L16.25 6.44111V11.8089C16.25 14.2592 14.2937 16.25 11.875 16.25C9.52742 16.25 7.61548 14.3746 7.50504 12.0239L7.5 11.8089V6.44111C7.5 3.99078 9.45629 2 11.875 2ZM11.875 3.25C10.211 3.25 8.84704 4.57962 8.75496 6.2598L8.75 6.44111V11.8089C8.75 13.5737 10.1516 15 11.875 15C13.539 15 14.903 13.6704 14.995 11.9902L15 11.8089V6.44111C15 4.67629 13.5984 3.25 11.875 3.25Z"
        fillRule="evenodd"
      />
      <path d="M18.125 9.5C18.4388 9.5 18.6986 9.73126 18.7432 10.0326L18.75 10.125L18.7498 12.3113C18.6635 15.8243 15.9846 18.6607 12.625 18.9717V21.375L12.6182 21.4674C12.5736 21.7687 12.3138 22 12 22C11.6548 22 11.375 21.7202 11.375 21.375V18.989C7.96627 18.7936 5.21374 16.0309 5.00995 12.5363L5 12.296V10.125C5 9.77982 5.27982 9.5 5.625 9.5C5.9388 9.5 6.19858 9.73126 6.24322 10.0326L6.25 10.125L6.24981 12.2806C6.32379 15.2912 8.71663 17.6881 11.6694 17.7488L11.8865 17.7491C14.8414 17.8033 17.3017 15.4822 17.4902 12.5193L17.5 12.296V10.125C17.5 9.77982 17.7798 9.5 18.125 9.5Z" />
    </svg>
  );
}
export default MicrophoneOn;
